import React from 'react';
import "./index.css";

function MainPage() {
    
    return(
        <>
        <div className="main-banner">
            <div>
                <h1>       </h1>
            </div>
            <div>
                <div className="doctor">   Doctor English</div>
    
            </div>
            <div className="where">
                <h2>김포시 구래동 김포한강4로</h2>
                <h2>420번길 88수퍼스타 타워 305호</h2>
            </div>
        </div>
        <div className="frame">
            <img  className="frame-img" src="https://ifh.cc/g/0l13r5.png" alt="프레임 사진"></img>
            </div>
            <div className="banners">
            <img className="banner"src="https://ifh.cc/g/pZzhkp.jpg" alt="교실사진"></img>
            <img className="banner" src="https://ifh.cc/g/kt3OA2.jpg" alt="교실사진"/>
            <img className="banner" src="https://ifh.cc/g/S7m2dH.jpg" alt="교실사진"/>
            <img className="banner" src="https://ifh.cc/g/RwAQjw.jpg" alt="교실사진"></img>
            <img className="banner" src="https://ifh.cc/g/h0SlsF.jpg" alt="교실사진"/>
            <img className="banner" src="https://ifh.cc/g/v5hvht.jpg" alt="교실사진"></img>
            <img className="banner" src="https://ifh.cc/g/XlA8rJ.jpg" alt="교실사진"/>
            <img className="banner" src="https://ifh.cc/g/WO6ta3.jpg" alt="교실사진"></img>
            <img className="banner" src="https://ifh.cc/g/RNQq4N.jpg" alt="교실사진"></img>    

            </div>
            <div className="doctorimg">

            </div>

      </>  
    );

}

export default MainPage;